import {APIClient} from '../../../utils/APIClient';
import {API_URL} from '../../../settings/local_settings';
import {isOk} from '../../../utils/apiResponse';

/**
 * Los pedidos de Conexiones › Cuentas en la 2.1. Son LOS MISMOS endpoints que la pantalla clásica
 * (contrato §3): ninguno es nuevo. Cada uno devuelve el objeto crudo del `APIClient`, que nunca
 * rechaza; quien llama decide con `isOk`.
 */

export function fetchAgencyAccounts() {
    return new APIClient(`${API_URL}agency/ad-accounts/`).call('GET');
}

/**
 * La actividad de las cuentas de paid media (`GlobalLineCandidatesService`), para agrupar «Sin
 * cliente». Es acompañamiento: si falla, la vista sale como lista simple.
 */
export function fetchCandidates() {
    return new APIClient(`${API_URL}agency/global-lines/candidates/`).call('GET');
}

/** Los clientes de la agencia que ve quien mira: el universo del buscador y de la sugerencia. */
export function fetchActiveClients() {
    return new APIClient(`${API_URL}agency/clients/active`).call('GET', {}, {cache: true});
}

/**
 * Conectar una cuenta a un cliente. Sin `dailyLimit`, SIN límite diario ni eventos: lo mismo que el
 * modal «Vincular una cuenta» del Panel 2.1 (`QuickConnectAccountModal`). «Cambiar de cliente» pasa
 * el límite del vínculo viejo, que vive en el vínculo y no en la cuenta. `accountId` es el id de la
 * PLATAFORMA.
 */
export function connectAccountToClient(clientId, channel, accountId, dailyLimit = null) {
    return new APIClient(`${API_URL}client/${clientId}/ad_account/add`).call('POST', {
        channel,
        account_id: String(accountId),
        daily_limit_type: dailyLimit ? dailyLimit.type : null,
        daily_limit_currency: dailyLimit ? dailyLimit.currency : null,
        daily_limit_value: dailyLimit ? dailyLimit.value : null,
    });
}

/** Los eventos elegidos de un vínculo (el mismo endpoint de `EditEventsModal`). */
export function saveSelectedActions(clientAdAccountId, selectedActions) {
    return new APIClient(`${API_URL}client/ad_account/${clientAdAccountId}/selected_actions`)
        .call('POST', {selected_actions: selectedActions});
}

/**
 * Después de crear un cliente, el GET cacheado de `agency/clients/active` (30 s) no lo trae: volver a
 * la pantalla dentro de esa ventana dejaba el buscador sin el cliente nuevo (review C-09).
 */
export function forgetActiveClients() {
    APIClient.clearCache('agency/clients/active');
}

/** Ignorar una cuenta sin cliente. `adAccountPk` es el id de Dashbo. GET y con guion bajo: es el de hoy. */
export function ignoreAccount(adAccountPk) {
    return new APIClient(`${API_URL}agency/ad_accounts/${adAccountPk}/snooze-unlinked`).call('GET');
}

/** Desconectar una cuenta (o tienda, o Escalafy) de su cliente. `clientAdAccountId` es el vínculo. */
export function disconnectFromClient(clientAdAccountId) {
    return new APIClient(`${API_URL}client/ad_account/${clientAdAccountId}/remove`).call('DELETE');
}

export {isOk};
